module.exports = __webpack_public_path__ + "static/Muli-Regular-877cf46a57ca3dbd6f2b864ec5621a3e.ttf";